<template>
  <history-item-template
    :createTime="action.createTime"
    :creatorName="action.creatorName"
    :comment="action.data.content"
    :vbAttachments="action.attachments"
    @downloadFile="({vbAttachment}) => $emit('downloadFile', {vbAttachment})"
  >
    <template #historyHeader>
      <p class="action-type flex-row flex__left inline-flex color__blue">
        <i class="fas fa-comment font-size__small"></i>
        <span class="font-size__small no_wrap">Gửi bình luận</span>
      </p>
      <!--build thong tin người nhận-->
      {{ receiverNames }}
      <comment-receivers-info
        :toUsers="action.toUsers"
      ></comment-receivers-info>
      <!--build thong tin người nhận:end-->
    </template>
  </history-item-template>
</template>

<script>
import HistoryTemplate from "../adminstration/ketluan/history-template";
import HistoryItemTemplate from "../common/layout/history-item-template";
import DocInReceiversInfo from "./doc-in-receivers-info";
import CommentReceiversInfo from "./comment-receivers-info";

export default {
  name: "comment-history-item",
  components: {
    CommentReceiversInfo,
    DocInReceiversInfo,
    HistoryItemTemplate,
    HistoryTemplate
  },
  props: ["action"],
  data() {
    return {
      receiverNames: ""
    };
  },

  watch: {
    action() {
      this.initComponent();
    }
  },

  created() {
    this.initComponent();
  },

  methods: {
    initComponent() {
      this.receiverNames = this.buildNameReceivers();
    },

    buildNameReceivers() {
      let action = this.action;
      if (action.toUsers && action.toUsers.length) {
        let temp_ = [`tới ${action.toUsers[0].toFullName}`];
        if (action.toUsers.length > 1)
          temp_.push(` và ${action.toUsers.length - 1} người khác`);
        return temp_.join(" ");
      } else {
        return "";
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/comment-history-item.vue